import api from "@/api/websiteApi"
import { uploadR2File } from "@/services/r2UploadService"
import { readWebsiteVideo } from "@/services/websiteVideoUploadService"

// Keep at most one downloaded video in memory; retries can reuse it while this view is open.
export async function runWebsiteVideoMigration(job, { signal, onProgress = () => {} } = {}) {
  const check = () => { if (signal?.aborted) throw new Error("Migration abgebrochen.") }
  const progress = (phase, value = null) => { check(); onProgress(phase, value) }
  progress("prepare")
  let session = await api.prepareWebsiteVideoMigration(job.file, signal)
  check()
  if (session.state === "ready") return session
  if (!session.uploaded) {
    if (!job.blob || job.sourceVersion !== session.sourceVersion) {
      job.blob = null
      progress("download", 0)
      const blob = await api.downloadWebsiteVideo(session.sourceFile, signal, (event) => {
        if (!signal?.aborted) onProgress("download", Math.min(100, Math.round(event.loaded / session.size * 100)))
      })
      check()
      if (blob.size !== session.size) throw new Error("Das Video wurde nicht vollständig geladen. Bitte erneut versuchen.")
      const file = new File([blob], job.file, { type: "video/mp4" })
      progress("check")
      await readWebsiteVideo(file)
      check()
      job.blob = file
      job.sourceVersion = session.sourceVersion
    }
    if (session.uploadExpiresAt <= Date.now() + 5000) {
      session = await api.prepareWebsiteVideoMigration(job.file, signal)
      check()
      if (session.state === "ready") return session
      if (session.sourceVersion !== job.sourceVersion) throw new Error("Das bisherige Video hat sich geändert. Bitte erneut versuchen.")
    }
    if (!session.uploaded) {
      progress("upload", 0)
      await uploadR2File(job.blob, session, { signal, onProgress: (loaded, total) => {
        if (!signal?.aborted) onProgress("upload", Math.round(loaded / total * 100))
      } })
      check()
    }
  }
  progress("verify")
  const result = await api.completeWebsiteVideoMigration({ file: job.file, sessionToken: session.sessionToken }, signal)
  check()
  job.blob = null
  return result
}
